/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import { applyMiddleware, combineReducers, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { all, fork } from "redux-saga/effects";
import { history, routeSagas } from "../router/router";
// import { createLogger } from 'redux-logger';
import {composeWithDevTools} from "redux-devtools-extension";
import {
  connectRouter,
  routerMiddleware,
  RouterState,
} from "connected-react-router";
import {
  HomePageData,
  homePageReducer,
  homePageSagas,
} from "../views/Pages/HomePage";
import {
  AppsByClassificationPageData,
  appsByClassificationPageReducer,
  appsByClassificationPageSagas,
} from "../views/Pages/AppsByClassification";
import {
  AppDetailsPageData,
  appDetailsPageReducer,
  appDetailsPageSagas,
} from "../views/Pages/AppDetailsPage";
import {
  SearchResultsPageData,
  SearchResultsPageReducer,
  searchResultsPageSagas,
} from "../views/Pages/SearchResultsPage";
import {
  MyAppsPageData,
  myAppsPageReducer,
  myAppsPageSagas,
} from "../views/Pages/MyAppsPage";
import {
  AppsByCategoryPageData,
  AppsByCategoryPageReducer,
  appsByCategoryPageSagas,
} from "../views/Pages/AppsByCategoryPage";
import {
  MainPageData,
  mainPageReducer,
  mainPageSagas
} from "../views/MainUi";

export interface PortalState {
  router: RouterState<unknown>;
  homePageData: HomePageData;
  appsByClassificationPageData: AppsByClassificationPageData;
  appDetailsPageData: AppDetailsPageData;
  searchResultsPageData: SearchResultsPageData;
  appsByCategoryPageData: AppsByCategoryPageData;
  myAppsPageData: MyAppsPageData;
  mainPageData: MainPageData
}

const rootReducer = (history: any) =>
  combineReducers<PortalState>({
    router: connectRouter(history),
    homePageData: homePageReducer,
    appsByClassificationPageData: appsByClassificationPageReducer,
    appDetailsPageData: appDetailsPageReducer,
    searchResultsPageData: SearchResultsPageReducer,
    appsByCategoryPageData: AppsByCategoryPageReducer,
    myAppsPageData: myAppsPageReducer,
    mainPageData: mainPageReducer,
  });

function* rootSaga() {
  let sagas = [
    ...routeSagas,
    ...homePageSagas,
    ...appsByClassificationPageSagas,
    ...appDetailsPageSagas,
    ...searchResultsPageSagas,
    ...appsByCategoryPageSagas,
    ...myAppsPageSagas,
    ...mainPageSagas
  ];

  yield all(sagas.map((s) => fork(s)));
}

function configureStore() {
  const sagaMiddleware = createSagaMiddleware();
  // const logger = createLogger();
  const middlewares = [routerMiddleware(history), sagaMiddleware];
  const store = createStore(rootReducer(history), {}, applyMiddleware(...middlewares));
//   const store = createStore(rootReducer(history), {}, composeWithDevTools(applyMiddleware(...middlewares)));

  sagaMiddleware.run(rootSaga);
  return store;
}

export default configureStore;
